import React, { useState, useEffect } from 'react'
import CheckBox from '../CheckBox'
import { useGlobal } from '../../../contexts/GlobalContext'

import {
  Container
} from './styles'

export const FilterCurrency = (props) => {
  const {
    filterValues,
    handleChangeCurrency
  } = props

  const { invokeServer } = useGlobal()
  const [paymethodList, setPaymethodList] = useState([])

  const getPaymethodList = () => {
    invokeServer('get', '/api/payment')
      .then(r => {
        if (r.data.msg === 'ok') {
          setPaymethodList(r.data.payment)
        }
      })
      .catch(err => {
        console.log(`${err.message}`);
      })
  }

  useEffect(() => {
    getPaymethodList()
  }, [])

  return (
    <Container>
      {paymethodList.map(cl => (
        <CheckBox
          key={cl.id}
          id={cl.id}
          label={cl.name}
          isChecked={filterValues?.currencyTypes.includes(cl.id)}
          onChange={val => handleChangeCurrency(val)}
        />
      ))}
    </Container>
  )
}
